import permissions from "app/permissions";
import { SpecialistServicePath } from "utils/constants";
import EnrollSpecialist from "./EnrollSpecialist";
import { tenants } from "utils/tenants";

export const resources = {
  isMenu: false,
  tenancies: [tenants.MU],
  name: SpecialistServicePath + "enroll-specialist/:type",
  permission: permissions.canEnrollSpecialists,
  custom: <EnrollSpecialist />,
};
